import { useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTenant } from "@/hooks/useTenant";
import { APP_NAME } from "@/lib/constants";

interface AuthPromptModalProps {
  open: boolean;
}

export const AuthPromptModal = ({ open }: AuthPromptModalProps) => {
  const { name: tenantName } = useTenant();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogin = () => {
    // Remember the page behind the modal so re-login returns the user to it.
    navigate("/login", { state: { from: location.pathname + location.search } });
  };

  return (
    <Dialog open={open} modal>
      <DialogContent className="sm:max-w-md" hideCloseButton>
        <DialogHeader>
          <DialogTitle className="text-xl">Not Logged In</DialogTitle>
          <DialogDescription className="text-base pt-4">
            You are not logged into {tenantName} {APP_NAME}. Please login.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4 pt-4">
          <Button onClick={handleLogin} className="w-full">
            Login
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
